import React, { useEffect, useState } from 'react';
import Bredcrum from '../../common/Bredcrum';
import { axiosInstance } from '../config';

const Gallery = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);  // Track the current page
    const [totalImages, setTotalImages] = useState(0);  // Track the total number of images
    const imagesPerPage = 9;  // Number of images per page

    useEffect(() => {
        setTimeout(() => window.scrollTo(0, 250), 200)
        getGalleryImages(page);
    }, [page]);  // Fetch images whenever page changes

    const getGalleryImages = (page) => {
        setLoading(true);
        axiosInstance.get(`get-images?page=${page}`)
            .then((res) => {
                // Update the total number of images in the state
                const fetchedImages = res?.data?.images || [];
                setTotalImages(res?.data?.totalImages || fetchedImages.length);  // Use totalImages or fallback to the fetched images count

                // Append the fetched images to the existing ones
                setData(fetchedImages);
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false);
            });
    };

    // Calculate total pages based on totalImages
    const totalPages = Math.ceil(totalImages / imagesPerPage);

    const loadMoreImages = (direction) => {
        if (!loading) {
            if (direction === 'next' && page < totalPages) {
                setPage(page + 1);  // Go to next page
            } else if (direction === 'prev' && page > 1) {
                setPage(page - 1);  // Go to previous page
            }
        }
    }; 


    return (
        <>
            <Bredcrum
                heading={'Our Certified Students'}
                path={[
                    { name: 'Our Certified Students', path: 'gallery' },
                ]}
            />
            <div className="my-5 pb-md-5">
                <div className="auto-container p-md-5 p-4 pb-4" style={{ backgroundColor: '#f2f2f2' }}>
                    <div className="row Gallery">
                        {data.slice(page * imagesPerPage - imagesPerPage, page * imagesPerPage).map((image, index) => {
                            if (index === 0) {
                                return (
                                    <div className="col-xl-3 left-column mb-5" key={index}>
                                        <img className="p-1 bg-dark" src={image.imageUrl} alt="Certified Students" />
                                    </div>
                                );
                            }
                            if (index === 1) {
                                return (
                                    <div className="col-xl-6 center-column mt-3 mt-xl-0 mb-5" key={index}>
                                        <img className="p-1 bg-dark" src={image.imageUrl} alt="Certified Students" />
                                    </div>
                                );
                            }
                            if (index === 2) {
                                return (
                                    <div className="col-xl-3 right-column mt-3 mt-xl-0 mb-5" key={index}>
                                        <img className="p-1 bg-dark" src={image.imageUrl} alt="Certified Students" />
                                    </div>
                                );
                            }
                            if (index === 3) {
                                return (
                                    <div className="col-xl-6 center-column mb-5" key={index}>
                                        <img className="p-1 bg-dark" src={image.imageUrl} alt="Certified Students" />
                                    </div>
                                );
                            }
                            if (index === 4) {
                                return (
                                    <div className="col-xl-3 right-column mt-3 mt-xl-0 mb-5" key={index}>
                                        <img className="p-1 bg-dark" src={image.imageUrl} alt="Certified Students" />
                                    </div>
                                );
                            }
                            if (index === 5) {
                                return (
                                    <div className="col-xl-3 left-column mt-3 mt-xl-0 mb-5" key={index}>
                                        <img className="p-1 bg-dark" src={image.imageUrl} alt="Certified Students" />
                                    </div>
                                );
                            }
                            if (index === 6) {
                                return (
                                    <div className="col-xl-3 right-column" key={index}>
                                        <img className="p-1 bg-dark" src={image.imageUrl} alt="Certified Students" />
                                    </div>
                                );
                            }
                            if (index === 7) {
                                return (
                                    <div className="col-xl-3 left-column mt-3 mt-xl-0" key={index}>
                                        <img className="p-1 bg-dark" src={image.imageUrl} alt="Certified Students" />
                                    </div>
                                );
                            }
                            if (index === 8) {
                                return (
                                    <div className="col-xl-6 center-column mt-3 mt-xl-0" key={index}>
                                        <img className="p-1 bg-dark" src={image.imageUrl} alt="Certified Students" />
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>

                    {loading && <div className="text-center mt-5">Loading...</div>}

                    {/* Pagination Buttons */}
                    <div className="text-center mt-5">
                        <button
                            onClick={() => loadMoreImages('prev')}
                            // disabled={page === 1 || loading}  // Disable the button on the first page
                            className="btn btn-dark py-2 mr-3"
                            style={{cursor: `${page === 1 ? 'not-allowed' : 'pointer'}`}}
                        >
                            Previous
                        </button>
                        <button className='mx-3 p-3 rounded-circle py-2 bg-white'>{page}</button>
                        <button
                            onClick={() => loadMoreImages('next')}
                            // disabled={page === totalPages || loading}  // Disable the button on the last page
                            style={{cursor: `${page === totalPages ? 'not-allowed' : 'pointer'}`}}
                            className="btn btn-success bg-green py-2 "
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Gallery; 
